import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import PublicNavbar from "../components/layout/PublicNavbar";
import { Button, Input } from "../components/common/Primitives";
import api, { formatApiError } from "../lib/api";
import Seo from "../components/Seo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match.");
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. You can now sign in.");
      setTimeout(() => nav("/login"), 900);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen text-ink">
      <Seo
        title="Reset Password | VenturaZ"
        description="Set a new password for your VenturaZ account."
        path="/reset-password"
        noindex
      />
      <Toaster richColors position="top-right" />
      <PublicNavbar />
      <section className="max-w-md mx-auto px-6 py-20">
        <div className="overline mb-3">SET A NEW PASSWORD</div>
        <h1 className="font-display text-3xl text-ink mb-6">Reset your password</h1>
        {!token ? (
          <div className="glass rounded-lg p-6 text-ink-soft">
            Missing or invalid reset link. <Link to="/forgot-password" className="text-gold">Request a new link →</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="glass rounded-lg p-6 space-y-4" data-testid="reset-form">
            <Input label="New Password (min 6)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} testId="reset-password" />
            <Input label="Confirm Password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} testId="reset-confirm" />
            <Button type="submit" disabled={loading} className="w-full" data-testid="reset-submit">
              {loading ? "Updating…" : "Update Password"}
            </Button>
          </form>
        )}
      </section>
    </div>
  );
}
